import { Row, Col, Select, Pagination } from "antd";
import React, { useState } from "react";

interface Props {
  totalItems: number;
  isMobileOrTablet: boolean;
  onPageChange?: (page: number, pageSize: number) => void;
  pageSizeOptions?: number[];
}

const ResponsivePagination: React.FC<Props> = ({
  totalItems,
  isMobileOrTablet,
  onPageChange,
  pageSizeOptions = [5, 10, 20],
}) => {
  const [pageSize, setPageSize] = useState(pageSizeOptions[0]);
  const [current, setCurrent] = useState(1);

  const handlePageChange = (page: number) => {
    setCurrent(page);
    onPageChange?.(page, pageSize);
  };

  const handlePageSizeChange = (value: number) => {
    setPageSize(value);
    setCurrent(1);
    onPageChange?.(1, value);
  };

  return (
    <Row
      gutter={[12, 12]}
      justify={isMobileOrTablet ? "center" : "space-between"}
      align="middle"
      style={{
        marginTop: 16,
        textAlign: isMobileOrTablet ? "center" : "unset",
      }}
    >
      <Col xs={24} sm={24} md={12} xl={12}>
        Results per Page{" "}
        <Select
          value={pageSize}
          style={{ width: 80 }}
          onChange={handlePageSizeChange}
          options={pageSizeOptions.map((n) => ({ value: n, label: String(n) }))}
        />{" "}
        of {totalItems} items
      </Col>

      <Col xs={24} sm={24} md={12} xl={12}>
        <Pagination
          style={{
            display: "inline-flex",
            float: isMobileOrTablet ? undefined : "inline-end",
          }}
          current={current}
          pageSize={pageSize}
          total={totalItems}
          showSizeChanger={false}
          onChange={handlePageChange}
        />
      </Col>
    </Row>
  );
};

export default ResponsivePagination;
